import React from 'react';
import styles from './Footer.module.scss'
import {ReactComponent as Folders} from "./../../images/folders.svg";

const Footer = () => {
    return (
        <footer className={styles.container}>
            <h2 className={styles.header}>ДОПОЛНИТЕЛЬНО</h2>
            <div className={styles.btnsContainer}>
                <a href={'/Положение о проекте СТАЛЬ ИТОГ.pdf'} download={'Положение о проекте СТАЛЬ ИТОГ.pdf'}
                   className={styles.btn}>
                    Порядок отбора
                    <div className={styles.folder}>
                        <Folders/>
                    </div>
                </a>
                <a href={'/Политика перс данных МОК.pdf'} download={'Политика перс данных МОК.pdf'}
                   className={styles.btn}>
                    Политика обработки персональных данных
                    <div className={styles.folder}>
                        <Folders/>
                    </div>
                </a>
                <a href={'/20_р_Об_Общественном_совете_проекта_СТАЛЬ.pdf'}
                   download={'20_р_Об_Общественном_совете_проекта_СТАЛЬ.pdf'}
                   className={styles.btn}>
                    Общественный совет
                    <div className={styles.folder}>
                        <Folders/>
                    </div>
                </a>
            </div>
            <div className={styles.communication}>
                <p className={styles.mail}>stal@belregion.ru</p>
                <p className={styles.mailTitle}>Правительство Белгородской области</p>
            </div>
        </footer>
    )
};

export default Footer;